<script>
export default {
    name: 'IconSortDown',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-sort-down"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M22 8l.248 39.387 6.564-6.563L32 44 20 56 8 44l3.188-3.176 6.56 6.56L17.5 8H22zm34 24v6H32v-6h24zm-8-12v6H32v-6h16zM40 8v6h-8V8h8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
